<template>
  <div>
    <div class="main__top">
      <div class="main__top--img">
        <img :src="download.logoFxh" style="height: 100%" />
      </div>
      <div class="main__top--title">
        <h1 style="font-size: 23px; margin: 0 0 7px 0">智芯焊</h1>
      </div>
    </div>
    <div class="main__middle"></div>

    <div class="main__bottom">
      <!--android-->
      <a
        href="https://app.gewuzhian.com/gwza_zxh.apk"
        class="main__bottom--button"
      >
        <img :src="download.androidLogo" />
        <span>Android下载</span>
      </a>
      <!--iphone-->
      <!-- <a href="itms-apps://itunes.apple.com/cn/app/idcom.gwza?mt=8"> -->
      <a
        href="https://apps.apple.com/cn/app/id6738172757"
        class="main__bottom--button"
      >
        <img :src="download.iosLogo" />
        <span>ios下载</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mixins } from "@/assets/js/metaMixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      download: global.download,
    };
  },
};
</script>

<style>
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  overflow: scroll;
}

.main__top {
  height: 250px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.main__top--img {
  height: 100px;
  width: 140px;
  margin: 0 auto 20px;
}

.main__top--title {
  width: 100%;
  text-align: center;
}

.main__middle {
  width: 250px;
  margin: 20px auto;
  text-align: center;
  border-top: 1px solid #e6e6e6;
}

.main__bottom {
  width: 250px;
  margin: 0 auto;
}

.main__bottom--button {
  text-decoration: none;
  height: 45px;
  width: 100%;
  border-radius: 45px;
  -webkit-appearance: none;
  border: 1px solid #b5b5b5;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 0;
  margin-bottom: 30px;
}

.main__bottom--button img {
  height: 25px;
  width: 25px;
  margin-right: 8px;
}

.main__bottom--button span {
  line-height: 120%;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/download/downloadZxh.vue